/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '../user';
import { WebSocketService } from './web-socket.service';
import { toString } from '@gh/core-util';
import { DialogService, WaitingService } from '@gh/core-ui';
import { UserRestService } from '@gh/builder-shared-data';

@Injectable()
export class MaintenanceService {
  numberOfMinutesBeforeMaintenance: number;
  isOpenedMaintenanceDialog: boolean;
  constructor(
    public userContext: BuilderUserContext,
    private dialogService: DialogService,
    private userService: UserRestService,
    private waitings: WaitingService,
    private webSocket: WebSocketService,
    ) {
  }

  connect(callback: (minutesBeforeMaintenance: number) => void): void {
    this.webSocket.on(`/ws/topic/maintenance-status`, (res: any) => {

      const { minutesBeforeMaintenance } = JSON.parse(res.body);
      callback(minutesBeforeMaintenance);
      this.numberOfMinutesBeforeMaintenance = minutesBeforeMaintenance;
      if (minutesBeforeMaintenance > 0) {
        if (!this.isOpenedMaintenanceDialog) {
          this.isOpenedMaintenanceDialog = true;
          this.dialogService.warning('lbl_maintenance_turn_off', {
            x: toString(this.numberOfMinutesBeforeMaintenance),
          }).subscribe(() => {
            this.userService.confirmMaintenance().subscribe(() => this.waitings.operator());
          });
        }
      }
    });
  }
}
